import ScrollOut from "scroll-out";

var resizeTimer;

const mqMedium = window.matchMedia("(min-width: 640px)");

$(window).on("resize", function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if (mqMedium.matches) {
            ScrollOut({
                targets: ".schedesettori__grid",
                threshold: 0.9,
                onShown: function() {
                    var el = $(".schedesettori__item"),
                        i = 0,
                        f = function() {
                            $(el[i++]).addClass("animated fadeInUp");
                            if (i < el.length) setTimeout(f, 200);
                        };
                    f();
                }
            });
        } else {
            ScrollOut({
                targets: ".schedesettori__grid",
                onShown: function() {
                    var el = $(".schedesettori__item"),
                        i = 0,
                        f = function() {
                            $(el[i++]).addClass(
                                "animated fadeInUp"
                            );
                            if (i < el.length) setTimeout(f, 200);
                        };
                    f();
                }
            });
        }
    }, 250);
}).resize();
